import {
  WIDGET_SUPPORT_CHATBOT,
  WidgetEvents,
} from '@wix/wix-chatbot-common/browser';
import { Store } from 'redux';

import { TRootState } from '../common/reducers';
import { selectConversationId } from '../common/selectors/chat';
import { ACTIONS, ROLE } from '../constants';
import { IMeta, TUi } from '../service/InitialChatData';
import { isFunction, isUndefined } from '../util/guards';
import { TMessage } from './createQueue';

export const postMessage = (event: WidgetEvents, payload: unknown): void => {
  const data = <const>{ event, payload };

  window.parent.postMessage({ type: WIDGET_SUPPORT_CHATBOT, data }, '*');
};

/**
 * Filter only text message from bot or agent
 */
const filterBotOrAgent = (message: TMessage): boolean =>
  !isFunction(message) &&
  message.type === ACTIONS.CHAT_ADD_ITEM &&
  !isUndefined(message.item.role) &&
  message.item.role !== ROLE.USER;

export const postNewMessages = (
  messages: TMessage[],
  store: Store<TRootState>,
  ui?: TUi,
  meta?: IMeta,
): void => {
  const count = messages.filter(filterBotOrAgent).length;
  postMessage(WidgetEvents.NEW, {
    count,
    conversationId: selectConversationId(store.getState()),
    nodeId: ui?.nodeId || '',
    lang: meta?.locale || '',
  });
};

export const postUrlChange = (url: string): void => {
  postMessage(WidgetEvents.UPDATE_WIDGET_URL, { url });
};
